import { useRef, useState } from 'react';

const defaultConfirmation = {
  title: 'Confirm save',
  message: 'Please review your inputs before saving this record.',
  confirmLabel: 'Save',
  confirmingLabel: 'Saving...',
  cancelLabel: 'Review',
};

function useSaveConfirmation() {
  const [confirmation, setConfirmation] = useState(null);
  const [isConfirming, setIsConfirming] = useState(false);
  const isConfirmingRef = useRef(false);

  function requestConfirmation(event, onConfirm, options = {}) {
    event?.preventDefault?.();

    if (isConfirmingRef.current) {
      return;
    }

    setConfirmation({
      ...defaultConfirmation,
      ...options,
      onConfirm,
    });
  }

  function cancelConfirmation() {
    if (isConfirming) {
      return;
    }

    setConfirmation(null);
  }

  async function confirmSave() {
    if (!confirmation?.onConfirm || isConfirmingRef.current) {
      return;
    }

    isConfirmingRef.current = true;
    setIsConfirming(true);

    try {
      await confirmation.onConfirm(createSubmitEvent());
      setConfirmation(null);
    } finally {
      isConfirmingRef.current = false;
      setIsConfirming(false);
    }
  }

  return {
    requestConfirmation,
    modalProps: {
      isOpen: Boolean(confirmation),
      isConfirming,
      title: confirmation?.title,
      message: confirmation?.message,
      confirmLabel: confirmation?.confirmLabel,
      confirmingLabel: confirmation?.confirmingLabel,
      cancelLabel: confirmation?.cancelLabel,
      onCancel: cancelConfirmation,
      onConfirm: confirmSave,
    },
  };
}

function createSubmitEvent() {
  return {
    preventDefault() {},
  };
}

export default useSaveConfirmation;
